'use strict';
import { getUserInfo } from '../avatar/avatar.js';

var imageLookupTimeout;
const get = async (source) => {
	// console.log("user get from",source)
	const user = getUserInfo(global.user);
	clearTimeout(imageLookupTimeout);
	imageLookupTimeout = setTimeout(() => {
		if (typeof global.handle!="udefined" && user.provider!="spotify") {
			var img = new Image();
			img.onerror = (e) => {
				 document.location.href='/auth/' + user.provider;
			};
			img.src = user.image;			
		}
	},1000);
	return global.user;
}


export { get };